import PanelGroup from "react-bootstrap/lib/PanelGroup";
import Panel from "react-bootstrap/lib/Panel";

const Accordion = ({ id, titleContent, children, eventKey = "1" }) => {
  return (
    <PanelGroup accordion id={id}>
      <Panel eventKey={eventKey}>
        <Panel.Heading>
          <Panel.Title toggle>{titleContent}</Panel.Title>
        </Panel.Heading>
        <Panel.Body collapsible>{children}</Panel.Body>
      </Panel>
    </PanelGroup>
  );
};

export default Accordion;
